'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var OptionProvider = require('../../components/OptionProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function DefaultComponent() {
  const {
    option: {
      label
    },
    isSelected,
    isFocused,
    isDisabled
  } = OptionProvider.useOption();
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: isSelected ? 'green' : 'black'
    }
  }, label ?? null, isFocused && ' (focused)', isDisabled && ' (disabled)'));
}

exports.DefaultComponent = DefaultComponent;
